import { Button } from 'components/Button/button';
import media from 'style-utils/media-queries';
import { withPrimaryTypeface, withSecondaryTypeface } from 'style-utils/text';
import { Flex } from 'style/flexbox.style';
import { H2 } from 'style/headings.style';
import styled from 'styled-components';

export const FooterContainer = styled(Flex)`
  width: ${({ theme: { footer } }) => footer.container.width};
  background-image: ${({ theme: { footer } }) =>
    footer.container.mobile.backgroundImage};
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  border-radius: ${({ theme: { footer } }) => footer.container.borderRadius};

  ${({ theme: { floatingButton, footer } }) =>
    footer.container.selfMarginHandling && `margin: 20px 0`};

  ${media.desktop`
    background-image: ${({ theme: { footer } }: any) =>
      footer.container.desktop.backgroundImage};
    padding: 8px 24px;
    margin: 30px 0 30px;
    min-height: 94px;
  `}
`;

export const FooterTitle = styled(H2)`
  font-size: ${({ theme: { footer } }) => footer.container.title.fontSize};
  line-height: ${({ theme: { footer } }) => footer.container.title.lineHeight};
  margin-bottom: ${({ theme: { footer } }) =>
    footer.container.title.marginBottom};
  margin-top: ${({ theme: { footer } }) => footer.container.title.marginTop};
  color: #ffffff;
  ${withSecondaryTypeface}
`;

export const FooterSubTitle = styled.p`
  font-size: ${({ theme: { footer } }) => footer.container.subtitle.fontSize};
  font-weight: ${({ theme: { footer } }) =>
    footer.container.subtitle.fontWeight};
  line-height: ${({ theme: { footer } }) =>
    footer.container.subtitle.lineHeight};
  color: #ffffff;
  margin-bottom: ${({ theme: { footer } }) =>
    footer.container.subtitle.marginBottom};
  margin-top: ${({ theme: { footer } }) => footer.container.subtitle.marginTop};
  ${withPrimaryTypeface}

  ${media.desktop`
    margin-bottom: 0;
  `}
`;

export const FooterButton = styled(Button)`
  /*   width: ${({ theme: { footer } }) => footer.container.button.width}; */
  height: 36px;
  /*   width: 170px; */
`;
